import { usePostHog } from "posthog-js/react";
import { FEATURE_FLAGS } from "~/shared/lib/posthog/posthog.constants";

export function useCanAccessPartnerInterviewRoundSettings() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PARTNER_INTERVIEW_ROUND_SETTINGS) ?? false;
}

export function useCanAccessJobInterviewPlan() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_JOB_INTERVIEW_PLAN) ?? false;
}

export function useShouldDisableNewInterviewRoundTypesEndpoint() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.KILL_SWITCH_USE_INTERVIEW_ROUND_TYPES_ENDPOINT) ?? false;
}

export function useCanAccessTiptapEditor() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_TIPTAP_EDITOR) ?? false;
}

export function useCanAccessParticipantJobDetail() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PARTICIPANT_JOB_DETAIL) ?? false;
}

export function useCanPreviewJobDetail() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PREVIEW_JOB_DETAIL) ?? false;
}

export function useCanAccessPartnersViewUpdate() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PARTNERS_VIEW_UPDATE) ?? false;
}

export function useCanAccessPartnerMutationUpdate() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_PARTNER_MUTATION_UPDATE) ?? false;
}

export function useCanAccessAssignmentUpdate() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_ASSIGNMENT_UPDATE) ?? false;
}

export function useCanAccessNewLogin() {
  const posthog = usePostHog();
  return posthog.isFeatureEnabled(FEATURE_FLAGS.RELEASE_NEW_LOGIN) ?? false;
}
